import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class LoadingSpinnerService {
  readonly showSpinner: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false)

  private numberOfRequests = 0

  handleRequest = (state: 'plus' | 'minus') => {
    this.numberOfRequests = (state === 'plus') ? this.numberOfRequests + 1 : this.numberOfRequests - 1
    this.showSpinner.next(this.numberOfRequests > 0)
  }
}
